import { render, staticRenderFns } from "./TrainingProgramEventListCard.vue?vue&type=template&id=53b31842"
import script from "./TrainingProgramEventListCard.vue?vue&type=script&lang=js"
export * from "./TrainingProgramEventListCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingProgramEventListCard.vue?vue&type=style&index=0&id=53b31842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports